// extracted by mini-css-extract-plugin
module.exports = {"container":"checkout-details_container__ZyKja","labelBig":"checkout-details_labelBig__J5enr","select":"checkout-details_select__vsCl9","list":"checkout-details_list__I90_u"};